import { render } from "./wxalipayrecent.vue?vue&type=template&id=c61fb4b2"
import script from "./wxalipayrecent.vue?vue&type=script&lang=js"
export * from "./wxalipayrecent.vue?vue&type=script&lang=js"

import "./wxalipayrecent.vue?vue&type=style&index=0&id=c61fb4b2&lang=less"
script.render = render

export default script